import React from 'react';

import { MenuItem, Button, Select } from '@material-ui/core';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import { monthNames } from '../../helpers/dateHelpers';

const MonthSelector = (props) => {

    const { okClick, cancelClick, showEndDate = true, startDate, endDate } = props;

    const [month, month_set] = React.useState(props.month);
    const [year, year_set] = React.useState(props.year);
    const [endMonth, endMonth_set] = React.useState(props.endMonth);
    const [endYear, endYear_set] = React.useState(props.endYear);

    var start = new Date(startDate);
    var end = new Date(endDate);

    var minYear = start.getFullYear();
    var minMonth = start.getMonth() + 1;

    var maxYear = end.getFullYear();
    var maxMonth = end.getMonth() + 1;

    var years = [];

    for (var i = minYear; i <= maxYear; i++) {
        years.push(i);
    }

    function getMonthItem(index, isEnd) {

        var selected = !isEnd ? month === index : endMonth === index;// && year === initialYear;

        var y = isEnd ? endYear : year;

        var a = (y === minYear && index < minMonth);
        var b = (y === maxYear && index > maxMonth);
        var c = (isEnd && y === year && month >= index);

        var notSelectable = a || b || c;

        return <div style={{
            padding: 10, textAlign: 'center', border: '1px solid black', cursor: notSelectable ? 'no-drop' : 'pointer',
            backgroundColor: selected ? '#3f51b5' : '', color: selected ? 'white' : notSelectable ? 'gray' : 'black',
            fontSize: 12, width: 70, minWidth: 70, margin: 5
        }} onClick={() => {
            if (!notSelectable) {
                if (isEnd) {

                    okClick(month, year, index, endYear);
                    endMonth_set(index);
                }
                else {
                    okClick(index, year, endMonth, endYear);
                    month_set(index);
                }
            }
        }}>
            <div>
                {monthNames[index - 1]}
            </div>
        </div>
    }

    return <div>
        <Dialog
            open={true}
            onClose={() => {
                // viewLogin_set(false);
            }}
            maxWidth={month && year && showEndDate ? 'md' : 'sm'}
            fullWidth={true}>
            <DialogTitle>Select Performance Analysis Period Dates</DialogTitle>
            <DialogContent>
                <div style={{ display: 'flex' }}>
                    <div style={{ width: '50%' }}>
                        <div style={{ display: 'flex', marginBottom: 10 }}>
                            <div style={{ marginRight: 10, marginTop: 4 }}>Year: </div>
                            <div>
                                <Select
                                    value={year ? year : ''}
                                    onChange={(event) => {
                                        year_set(event.target.value);
                                        //month_set('');

                                        if (event.target.value > endYear) {
                                            endMonth_set('');
                                            endYear_set('');
                                        }
                                        else if (endYear === event.target.value && endMonth <= month) {
                                            endMonth_set('');
                                        }
                                    }}
                                >
                                    <MenuItem value={""}></MenuItem>
                                    {years.map(m =>
                                        <MenuItem value={m} key={`startY_${m}`}>{m}</MenuItem>
                                    )}
                                </Select>
                            </div>
                        </div>
                        {year && <div>
                            <div>Select Month</div>
                            <div style={{ display: 'flex' }}>
                                {getMonthItem(1)}
                                {getMonthItem(2)}
                                {getMonthItem(3)}
                                {getMonthItem(4)}
                            </div>
                            <div style={{ display: 'flex' }}>
                                {getMonthItem(5)}
                                {getMonthItem(6)}
                                {getMonthItem(7)}
                                {getMonthItem(8)}
                            </div>
                            <div style={{ display: 'flex' }}>
                                {getMonthItem(9)}
                                {getMonthItem(10)}
                                {getMonthItem(11)}
                                {getMonthItem(12)}
                            </div>
                        </div>}
                    </div>
                    {showEndDate && <div>
                        {month && year && <div style={{ width: '50%' }}>
                            <div style={{ fontSize: 26 }}>End Period</div>
                            <div style={{ display: 'flex', marginBottom: 10 }}>
                                <div style={{ marginRight: 10, marginTop: 4 }}>Year: </div>
                                <div>
                                    <Select
                                        value={endYear ? endYear : ''}
                                        onChange={(event) => {
                                            endYear_set(event.target.value);
                                            endMonth_set('');
                                        }}
                                    >
                                        <MenuItem value={""}></MenuItem>
                                        {years.filter(e => e >= year).map(m =>
                                            <MenuItem value={m} key={`startY_${m}`}>{m}</MenuItem>
                                        )}
                                    </Select>
                                </div>
                            </div>
                            {endYear && <div>
                                <div>Select Month</div>
                                <div style={{ display: 'flex' }}>
                                    {getMonthItem(1, true)}
                                    {getMonthItem(2, true)}
                                    {getMonthItem(3, true)}
                                    {getMonthItem(4, true)}
                                </div>
                                <div style={{ display: 'flex' }}>
                                    {getMonthItem(5, true)}
                                    {getMonthItem(6, true)}
                                    {getMonthItem(7, true)}
                                    {getMonthItem(8, true)}
                                </div>
                                <div style={{ display: 'flex' }}>
                                    {getMonthItem(9, true)}
                                    {getMonthItem(10, true)}
                                    {getMonthItem(11, true)}
                                    {getMonthItem(12, true)}
                                </div>
                            </div>}
                        </div>}
                    </div>}
                </div>

            </DialogContent>
            <DialogActions>
                {/* <Button disabled={!year || !month || (showEndDate && (!endYear || !endMonth))}
                    onClick={() => { okClick(month, year, endMonth, endYear) }}
                    color="primary">
                    OK
            </Button> */}
                <Button onClick={() => { cancelClick() }} color="secondary">
                    Cancel
            </Button>
            </DialogActions>
        </Dialog>
    </div>
};

export default MonthSelector;



// WEBPACK FOOTER //
// ./src/portfolioEntryWizard/components/MonthSelector.js